import { render } from "./BasicList.vue?vue&type=template&id=0974411a&scoped=true&ts=true"
import script from "./BasicList.vue?vue&type=script&lang=ts"
export * from "./BasicList.vue?vue&type=script&lang=ts"

import "./BasicList.vue?vue&type=style&index=0&id=0974411a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0974411a"]])

export default __exports__